module.exports = "<div class=\"page-title\" md-colors=\"{background: 'primary-500'}\"><div class=\"breadcrumb\">Pulpit</div><div class=\"title md-padding\"><h1 class=\"md-headline\">{{ vm.title }}</h1></div></div>";


//////////////////
// WEBPACK FOOTER
// ./client/components/page-title/page-title.pug
// module id = 334
// module chunks = 0